import styled from '@emotion/styled';
import _ from 'lodash';
import { NextPage } from 'next';
import { memo } from 'react';
import { HiOutlineChevronRight } from 'react-icons/hi';
import { IArticle } from 'src/interface/section';
import { IBreadcrumbData } from 'src/interface/widgets';
import { splitRote } from 'src/utils/helper';

type Props = {
  data?: IArticle;
  title?: string;
  tag?: string;
  router?: any;
  isTranslate?: boolean;
  enTitle?: string;
};
const WidgetBreadcrumb: NextPage<Props> = ({ data, title = '', tag, router = null, isTranslate = false }) => {
  if (_.isEmpty(data) && _.isEmpty(tag)) return null;
  const themePage = router ? splitRote(router) : '';

  const _data: IBreadcrumbData[] = [
    {
      icon: '',
      nameTh: 'หน้าแรก',
      nameEng: 'Home',
      link: null
    },
    {
      icon: tag ? (
        <>
          <HiOutlineChevronRight /> <p className='title-custom'> {`${title}`} </p>
        </>
      ) : (
        <HiOutlineChevronRight />
      ),
      nameTh: router?.pathname !== `${themePage}/galleries/[id]` ? `${data ? data.section?.th : tag}` || '' : 'แกลลอรี่',
      nameEng: data ? data.section?.en : tag,
      link: router?.pathname !== `${themePage}/galleries/[id]` ? `/category/${data?.section?.en}` : ''
    },
    {
      icon: <HiOutlineChevronRight />,
      nameTh: router?.pathname !== `${themePage}/galleries/[id]` ? data?.subCategory?.th : data?.title,
      nameEng: data ? data.subCategory?.en : tag,
      link: router?.pathname !== `${themePage}/galleries/[id]` ? `/category/${data?.section?.en || ''}/${data ? data.subCategory?.en : tag}` : router.asPath
    },
    {
      icon: <HiOutlineChevronRight />,
      nameTh: router?.pathname === `${themePage}/video/[cid]` ? router.query.sub || router.query.cid : '',
      nameEng: '',
      link: router?.asPath
    }
  ];
  return (
    <WidgetWrapper id='widget-breadcrumb'>
      <nav aria-label='breadcrumb'>
        <ul className='breadcrumb'>
          {_data.map(
            (item: IBreadcrumbData, index: number) =>
              item.nameTh &&
              item.nameEng && (
                <li key={index} className='breadcrumb-item'>
                  {item.icon}
                  {item.link ? (
                    <a href={item.link} title={isTranslate ? item.nameEng : item.nameTh} aria-label={isTranslate ? item.nameEng : item.nameTh}>
                      <span>{isTranslate ? item.nameEng : item.nameTh}</span>
                    </a>
                  ) : (
                    <a href='/' title={isTranslate ? item.nameEng : item.nameTh} aria-label={isTranslate ? item.nameEng : item.nameTh}>
                      {isTranslate ? item.nameEng : item.nameTh}
                    </a>
                  )}
                </li>
              )
          )}
          {/* {data?.title && (
            <li className='breadcrumb-item title'>
              <HiOutlineChevronRight />
              <span>{isTranslate && enTitle ? enTitle : data?.title}</span>
            </li>
          )} */}
        </ul>
      </nav>
    </WidgetWrapper>
  );
};

const WidgetWrapper = styled.div`
  position: relative;
  display: flex;
  max-width: 1300px;
  margin: auto;
  padding-top: 30px;
  @media (max-width: 767px) {
    flex-direction: column;
    padding: 30px 0 10px 0px;
  }

  .title-custom {
    color: var(--black-color);
    opacity: 0.65;
    padding-right: 5px;
  }

  .cat--title {
    position: relative;
    background: var(--primary-color);
    max-width: max-content;
    padding: 5px 16px;
    color: #fff;
    margin: 0 20px 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
    white-space: nowrap;
    @media (max-width: 475px) {
      padding: 2px 8px;
      margin: 0 10px 0 0;
    }
    p {
      font-size: 16px;
      font-weight: 500;
      @media (max-width: 768px) {
        font-size: 14px;
      }
      @media (max-width: 475px) {
        font-size: 12px;
      }
    }
  }

  ul.breadcrumb {
    display: flex;
    flex-wrap: wrap;
    margin: 0;
    padding: 15px 0 15px;
    @media (max-width: 768px) {
      padding: 10px 0 10px;
    }
    @media (max-width: 475px) {
      padding: 5px 0 5px;
    }
    a {
      text-transform: capitalize;
      color: var(--black-color);
      opacity: 0.95;
      font-weight: 400;
      font-size: 14px;
      &:hover {
        color: var(--black-color);
        opacity: 0.25;
      }
    }
    svg {
      color: var(--black-color);
      opacity: 0.45;
      font-weight: 300;
    }
    .breadcrumb-item {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      &.title {
        
        @media (max-width: 690px) {
          display: none;
        }
      }

      a,
      p {
        font-size: 14px;
        font-weight: 500;
  
        span {
          color: var(--primary-color);
        }
      }
      &:not(:last-child) {
        span {
          color: var(--black-color);
          /* opacity: 0.95; */
        }
      }
      &:last-child {
        span {
          color:var(--gray-color);
        }
        a {
          color: var(--black-color);
          /* opacity: 0.85; */
          pointer-events: none;
          user-select: none;
        }
      }
    }
  }
  @media (max-width: 1024px) {
    ul.breadcrumb {
      a {
        font-size: 14px;
      }
    }
  }
`;

export default memo(WidgetBreadcrumb);
